import React from 'react'
import TileIcon from '../svg/TileIcon'
import './WorkplaceFooter.css'
import Conditional from './Conditional'
import FWOCustomerTailoredInformation from '../home/FWOCustomerTailoredInformation'
import * as Config from '../../public/external-links'

type WorkplaceFooterProps = {
  isLoading: boolean
  userProfile: any
}
type WorkplaceFooterState = null
class WorkplaceFooter extends React.Component<
  WorkplaceFooterProps,
  WorkplaceFooterState
> {
  render() {
    return (
      <div className="workplaceFooter">
        <h3>Tailored workplace information</h3>
        <div>
          <Conditional if={!this.props.isLoading}>
            <FWOCustomerTailoredInformation
              UserWorkplaceType={this.props?.userProfile?.userWorkplaceType}
            />
          </Conditional>
        </div>
        <div>
          <a href={`${Config.HOME_SUBSCRIPTION_PREF_URL}`}>
            <TileIcon name="subscription" />

            <strong className="pl-2">Subscription preferences</strong>
          </a>
        </div>
        <div>
          <a href={`${Config.HOME_LIBRARY_URL}`}>
            <TileIcon name="library" />
            <strong className="pl-2">Library</strong>
          </a>
        </div>
      </div>
    )
  }
}

export default WorkplaceFooter
